export default class ItemDetailElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('item-detail', ItemDetailElement);